export default "__VITE_ASSET__09a5574b__"